import React from "react"
import crySvg from "../images/icon/cry.svg"

const Empty = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: 80,
      }}
    >
      <img src={crySvg} alt="" style={{ marginBottom: 0, width: 24 }} />
      <span style={{ color: "#c5c5c5", fontSize: 22, marginLeft: 10 }}>
        暂无数据更新, 请稍后关注
      </span>
    </div>
  )
}

export default Empty
